import React, { FC } from 'react';
import WarningModal from '../../WarningModal';
import { formatMessage, FormattedMessage } from '@/utils/i18n';

type Props = {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const UpRiskWarningModal: FC<Props> = ({ show, onConfirm, onCancel }) => {
  const i18nBasePath = 'CreateRiskProfile.UpRiskWarningModal';
  return (
    <WarningModal
      show={show}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel={formatMessage(`${i18nBasePath}.ConfirmButton`)}
      cancelLabel={`${i18nBasePath}.CancelButton`}
      title={formatMessage(`${i18nBasePath}.Title`)}
      body={<FormattedMessage tagName="p" id={`${i18nBasePath}.Body`} />}
    />
  );
};
